// @ts-nocheck
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useScorekeepers(statusFilter?: string) {
  return useQuery({
    queryKey: ["scorekeepers", statusFilter],
    queryFn: async () => {
      let q = supabase.from("manage_scorekeepers").select("*").order("name");
      if (statusFilter && statusFilter !== "all") q = q.eq("status", statusFilter);
      const { data, error } = await q;
      if (error) throw error;
      return data;
    },
  });
}

export function useScorekeeperAssignments(eventId: string | null) {
  return useQuery({
    queryKey: ["scorekeeper-assignments", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_scorekeeper_assignments")
        .select("*, scorekeeper:manage_scorekeepers(*)")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useScorekeeperAvailability(eventId: string | null) {
  return useQuery({
    queryKey: ["scorekeeper-availability", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_scorekeeper_availability")
        .select("*, scorekeeper:manage_scorekeepers(id, name, city, state, preferred_city)")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useScorekeeperAvailabilityAll() {
  return useQuery({
    queryKey: ["scorekeeper-availability-all"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_scorekeeper_availability")
        .select("*");
      if (error) throw error;
      return data;
    },
  });
}

export function useScorekeepersEventSummary(eventId: string | null) {
  return useQuery({
    queryKey: ["scorekeepers-event-summary", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_scorekeepers_event_summary")
        .select("*")
        .eq("event_id", eventId!);
      if (error) throw error;
      return data;
    },
  });
}

export function useUpcomingEventsForScorekeepers() {
  return useQuery({
    queryKey: ["upcoming-events-for-scorekeepers"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("events")
        .select("id, name, start_date, end_date, venue_id, venue_name, venue_city, additional_venue_ids")
        .gte("end_date", new Date().toISOString().split("T")[0])
        .order("start_date");
      if (error) throw error;
      return data;
    },
  });
}

export function useVenuesForScorekeepers(venueIds: string[]) {
  return useQuery({
    queryKey: ["venues-for-scorekeepers", venueIds],
    enabled: venueIds.length > 0,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("venues")
        .select("id, name, city, state")
        .in("id", venueIds);
      if (error) throw error;
      return data;
    },
  });
}

export function useVenueCourtsForScorekeepers(eventId: string | null) {
  return useQuery({
    queryKey: ["event-courts-sk", eventId],
    enabled: !!eventId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("event_courts")
        .select("*")
        .eq("event_id", eventId!)
        .eq("is_active", true)
        .order("sort_order");
      if (error) throw error;
      return data;
    },
  });
}

export function useScorekeeperDetail(scorekeeperId: string | null) {
  return useQuery({
    queryKey: ["scorekeeper-detail-assignments", scorekeeperId],
    enabled: !!scorekeeperId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("manage_scorekeeper_assignments")
        .select("*, event:events(id, name, start_date, end_date)")
        .eq("scorekeeper_id", scorekeeperId!)
        .order("assignment_date", { ascending: false });
      if (error) throw error;
      return data;
    },
  });
}
